import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-robot-submenu',
  templateUrl: './price-robot-submenu.component.html',
  styleUrls: ['./price-robot-submenu.component.scss']
})
export class PriceRobotSubmenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
